<style src="./ControlPanel" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Controle do Sistema <small>Define as configurações para o funcionamento do sistema</small></h5>
          </div>
          
          <div class="ibox-content">
            <form class="form-horizontal" @submit.prevent="saveChanges">
              <div class="form-group">
                <label class="col-sm-3 control-label">
                  Direito de uso do estacionamento <br/>
                  <small class="text-muted">O direito de uso define se o usuário irá usufruir das vagas como sendo um estacionamento único ou se cada vaga será tratada de forma distinta, não reconhecedo o crédito de outra vaga.</small>
                </label>

                <div class="col-sm-9">
                  <div class="radio i-checks"><label> <input type="radio" value="false" v-model="form.fullRightOfUse" name="fullRightOfUse"> <i></i> Nova cobrança ao mudar de vaga (Direito parcial de uso)</label></div>
                  <div class="radio i-checks"><label> <input type="radio" checked="" value="true" v-model="form.fullRightOfUse" name="fullRightOfUse"> <i></i> Utiliza o crédito restante ao mudar de vaga (Direito total de uso) </label></div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <label class="col-sm-3 control-label">WhatsApp</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" v-model="form.whatsapp" placeholder="Ex: 5511999999999" />
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <label class="col-sm-3 control-label">E-mail</label>
                <div class="col-sm-9">
                  <input type="email" class="form-control" v-model="form.email" placeholder="Ex: contato@empresa.com" />
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <label class="col-sm-3 control-label">Telefone</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" v-model="form.phone" placeholder="Ex: (11) 3333-4444" />
                </div>
              </div>

              <div class="hr-line-dashed"></div>
                <div class="form-group">
                  <div class="col-sm-4 col-sm-offset-2">
                    <button class="btn btn-primary" type="submit" :disabled="waitingSubmit">
                      Salvar Alterações
                    </button>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from '@/plugins/toast'

export default {
  data () {
    return {
      waitingSubmit: false,
      form: {
        fullRightOfUse: true,
        whatsapp: '',
        email: '',
        phone: '',
      }
    }
  },
  async mounted () {
    try {
      const form = await this.$store.dispatch('CONTROL-PANEL/GetConfigurations');
      this.form.fullRightOfUse = form.fullRightOfUse;
      this.form.whatsapp = form.contactInfos?.whatsapp || '';
      this.form.email = form.contactInfos?.email || '';
      this.form.phone = form.contactInfos?.phone || '';

    } catch (error) {
      console.log(error)
      toast.error('Não foi possível carregar as configurações')
    }
  },
  methods: {
    async saveChanges() {
      this.waitingSubmit = true

      try {
        await this.$store.dispatch('CONTROL-PANEL/SaveConfigurations', this.form)
        toast.success('Alterações salva com sucesso')
      } catch (error) {
        console.log(error)
        toast.error('Não foi possível salvar as configurações')
      }

      this.waitingSubmit = false
    }
  }
}
</script>